var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade-left","mode":"out-in"}},[_c('router-view',{key:'p_' + _vm.$router.name})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }